<template>
  <base-modal
    :reference="'addGeoPoint'"
    :title="'Añadir punto'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
    :size="'md'"
  >
    <template v-slot:body v-if="show">
        <div>
            <p>
                Añadir un punto a la zona <strong>{{suprazone.name}}</strong>
            </p>
        </div>
        <div>
            <p class="alert-info font-weight-bold py-1 px-5">
                Importante: los hoteles se tienen que añadir en el sistema de reservas y después sincronizar
            </p>
        </div>
        <form>
            
            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>Nombre del punto (hotel o parada) <span class="text-danger">[campo obligatorio]</span></label>
                    <b-form-input
                        type="text"
                        v-model="form.name"
                        placeholder="Inserte nombre"
                        style="width: 17vw"
                    ></b-form-input>
                </div>
            </div>
            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>Dirección</label>
                    <b-form-input
                        type="text"
                        v-model="form.address"
                        placeholder="Inserte dirección"
                        style="width: 17vw"
                    ></b-form-input>
                </div>
            </div>
            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>¿Se trata de un hotel?</label>
                    <v-select
                        :options="booleanOptions"
                        :reduce="(option) => option.value"
                        label="label"
                        v-model="form.is_hotel"
                        style="width: 17vw"
                        class="border"
                    >
                    </v-select>
                </div>
            </div>

            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>¿Es una parada de recogida de PAX?</label>
                    <v-select
                        :options="booleanOptions"
                        :reduce="(option) => option.value"
                        label="label"
                        v-model="form.is_pickup"
                        style="width: 17vw"
                        class="border"
                    >
                    </v-select>
                </div>
            </div>

            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>¿Es el punto de encuentro del servicio de recogidas?</label>
                    <v-select
                        :options="booleanOptions"
                        :reduce="(option) => option.value"
                        label="label"
                        v-model="form.is_beggining"
                        style="width: 17vw"
                        class="border"
                    >
                    </v-select>
                </div>
            </div>

            <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>Resort <span class="text-danger">[campo obligatorio]</span></label>
                    <v-select
                        :options="subzones_list"
                        :reduce="(option) => option.id"
                        label="name"
                        v-model="form.sub_zone"
                        style="width: 17vw"
                        class="border"
                    >
                    </v-select>
                </div>
            </div>

            <!-- <div class="d-flex w-100 my-3">
                <div class="d-flex flex-column align-items-sm-baseline">
                    <label>Punto de recogida (correspondiente al resort elegido)</label>
                    <v-select
                        :options="geopointsBySubzone"
                        :reduce="(option) => option.id"
                        label="name"
                        v-model="form.pickup_point"
                        style="width: 17vw"
                        class="border"
                    >
                    </v-select>
                </div>
            </div> -->

            <div v-if="errors">
                <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                    Los campos 'nombre' y 'resort' son obligatorios
                </p>
            </div>
            
        </form>
    </template>
    
  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";

export default {
  components: {
    BaseModal,
  },
  props: {
      suprazone: {
          type: Object,
          required: false,
      }
  },
  data() {
    return {
        show: false,
        submitAllowed: false,
        form: {
            name: '',
            address: '',
            active: false,
            is_hotel: false,
            is_pickup: false,
            is_beggining: false,
            //pickup_point: 0,
            sub_zone: 0,
            trekksoft_id: 0,
            active: true,
        },
        booleanOptions: [
            {
                value: true,
                label: 'Sí'
            },
            {
                value: false,
                label: 'No',
            }
        ],
        subzones_list: [],
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
      const current = "addGeoPoint";
      
      if (modalId == current) {
          
        this.show = true

        const data = {
            'suprazone_id': this.suprazone.id,
        }
        this.subzones_list = await this.$store.dispatch("subzones/getSubzonesBySuprazone", data)
        await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
        
        
        // get data
      }
    });
  },
  beforeDestroy() {
      
  },
  methods: {
    async acceptAction() {
        if ( this.errors ) {
            return 
        }
        
        let data = {
            payload: {...this.form}
        }
        await this.$store.dispatch("geopoints/createGeoPoint", data )
        data = {
            'suprazone_id': this.suprazone.id,
        }
        await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
        // reset form data
        this.form = {
            name: '',
            address: '',
            active: false,
            is_hotel: false,
            is_pickup: false,
            is_beggining: false,
            //pickup_point: 0,
            sub_zone: 0,
            trekksoft_id: 0,
            active: true,
        }

        this.$bvModal.hide("addGeoPoint");
        this.$notify({
            group: "foo",
            title: "Punto geográfico añadido",
            text: "Se ha creado un punto geográfico",
            type: "success",
        });
    },
    async onSearchStops(search, loading) {
      
    },
  },
  computed: {
        ...mapGetters(['geopointsListAdmin']),
        errors() {
            if (this.form.name == '' || this.form.sub_zone == 0 ) {
                return true
            }
            return false
        },
        geopointsBySubzone() {
            let filtered = this.geopointsListAdmin.filter(
                item => item.sub_zone.id == this.form.sub_zone
            )
            return filtered
        }
  },
    watch: {
    }
};
</script>